import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { usePageTitle } from '@/hooks/use-page-title';
import { Layers } from 'lucide-react';

/**
 * Fallback page in case the browser lands on the SPA /auth/callback route.
 * Under the BFF flow, the actual callback is handled server-side at
 * /api/auth/callback, so this page should rarely be reached.
 */
export default function CallbackPage() {
    usePageTitle('Authenticating...');
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/', { replace: true });
    }, [navigate]);

    return (
        <div className="flex flex-col items-center justify-center gap-4 p-8">
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-indigo-100">
                <Layers size={24} className="text-indigo-600" />
            </div>
            <p className="text-sm text-slate-500">Completing authentication...</p>
        </div>
    );
}
